import React from 'react'
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import {
    css,
    Header as AppHeader,
    MainNav,
    Heading,
    Section,
    Div,
    Link as SubLink,
    Icon,
    SubMenu,
} from "@bdfx/mergado-ui-kit"

import AutocompleteGodProjects from "./autocomplete-god-projects"

import { URL } from "app/config/api-config"
import trans from "trans"
import Mergado from "app/helpers/mergado"
import { getTokenExpiration, deleteToken } from "app/helpers/session"
import {projectId, eshopId, isGodModeOn, isIncognitoOn} from "app/helpers/api"
import HeaderLink from "./header-link"
import {allowSuperadminForUsers} from "template-edit/components/helper";
import {RouterType, withRouter} from "./routes";
import {setBlockNavigation} from "template-edit/reducers";
import { Project } from '../types/model-types';

interface Props {
    router: RouterType
    blockNavigation: boolean
    project: Project
    disabled?: boolean
    setBlockNavigation: typeof setBlockNavigation
}

interface State {
    showMenu: boolean
}

class Header extends React.PureComponent<Props, State> {
    private timeout = null

    constructor(props) {
        super(props)

        this.state = {
            showMenu: false,
        }
    }

    componentDidMount() {
        const exp: number = getTokenExpiration()
        const secondsReload = 5
        this.timeout = (exp - new Date().getTime())
        if (exp > 0 && exp - new Date().getTime() > 60) {
            setTimeout(() => {
                deleteToken()
                location.reload()
            }, this.timeout - (secondsReload * 1000))
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps && prevProps.router.location && prevProps.router.location !== this.props.router.location) {
            const hint = document.getElementById('muk-popuphint')
            if (hint) {
                hint.classList.remove("m-active")
            }
            sessionStorage.setItem('last_location', location.pathname)
            document.title = "Feed Image Editor"
            /*if(action !== "REPLACE") {*/
                Mergado.setAppRoute(`${location.pathname}${location.search}${location.hash}`);
            /*}*/

            if(window.performance) {
                console.debug("window.performance works fine on this browser");
            }
            if (performance.navigation.type === 1) {
                console.debug( "This page is reloaded" );
            } else {
                console.debug( "This page is not reloaded");
            }
        }
    }

    deleteToken = () => { deleteToken(); location.reload() }
    openHelp = () => Mergado.openWindow(trans('blog_link'))

    closeMenu = () => this.setState({showMenu: false})

    render() {
        const {project, blockNavigation} = this.props
        const url = this.props.router.location.pathname
        const {showMenu} = this.state

        if (url === '/oauth2') {
            return <div/>
        }

        const linkClass = blockNavigation ? 'disabled-link' : ''
        const userId = project.user && project.user.id ? project.user.id : null

        const styleLogo = {
            display: "inline-block",
            verticalAlign: "text-bottom"
        }

        const logo = <span>
                        <Logo className={`active ${linkClass}`} onClick={(e) => this.deleteToken()} tabIndex={-1}>
                            <Icon type={'feedimageeditor'} size={32} style={styleLogo} />
                            <Icon type={'refresh'} size={28} color={"#364b7b"} style={styleLogo} />
                        </Logo>
                        <Link to={`/eshop/${eshopId}/project/${projectId}`} className={linkClass}>
                            <StyledLogoImg>
                            <img src={`${URL.publicPath}/img/logo-type.svg`} alt="Feed Image Editor"/>
                            </StyledLogoImg>
                        </Link>
                    </span>

        return (
            <>
                <HeaderStyled className={`${showMenu ? 'show-menu' : ""}`}>
                    {!isIncognitoOn &&
                        <SubMenu >
                            <Heading type="5" className="project-name">
                                {project && project.shop_name ? project.shop_name + " - " : ""}
                                {project && project.name ? project.name : ""}
                            </Heading>

                            <SubLink onClick={this.openHelp}>
                                <Icon color="blue" type="question-circle-o"><strong>{trans("help")}</strong></Icon>
                            </SubLink>

                            {isGodModeOn && this.props.project.godAllProjects ?
                                <AutocompleteGodProjects godAllProjects={this.props.project.godAllProjects}/>
                            : null}
                        </SubMenu>
                    }
                    <MobileMenu onClick={() => this.setState({showMenu: !showMenu})}>
                        <Icon type={'bars'} size={20}>MENU</Icon>
                    </MobileMenu>

                    <MainNav className="app-header-links" logo={logo}>
                        <>
                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}`} exact location={url} close={this.closeMenu}>
                                {trans("templates")}
                            </HeaderLink>

                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}/previews`} location={url} close={this.closeMenu}>
                                {trans("previews")}
                            </HeaderLink>

                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}/diagnostics`} location={url} close={this.closeMenu}>
                                {trans("diagnostics")}
                            </HeaderLink>

                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}/products`} location={url} close={this.closeMenu}>
                                {trans("products")}
                            </HeaderLink>

                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}/settings`} location={url} close={this.closeMenu}>
                                {trans("settings")}
                            </HeaderLink>

                            {userId && (allowSuperadminForUsers.includes(userId) || (!isIncognitoOn && isGodModeOn && this.props.project.godAllProjects)) &&
                            <HeaderLink route={`/eshop/${eshopId}/project/${projectId}/superadmin`} location={url} close={this.closeMenu}>
                                <span title={`${userId}`} className={'some-users-only'}>Superadmin</span>
                            </HeaderLink>
                            }

                        </>
                    </MainNav>
                </HeaderStyled>
                <StyledDiv/>
            </>
        )
    }
}

const StyledDiv = css(Div)({
    paddingBottom: '60px',
    marginBottom: '15px',
})

const StyledLogoImg = css('span')({
    ' img': {
        height: '14px',
        width: '200px',
        verticalAlign: "middle",
    },
    display: 'inline-block',
    visibility: 'visible',
})

const HeaderStyled = css(AppHeader)({
    overflow: 'inherit',
    '@media screen and (max-width: 1024px)': {
        height: "auto",
        minHeight: "60px",
        ".app-header-links": {
            height: "60px",
        },
        ".app-header-links .m-links": {
            display: "none",
            marginTop: "50px",
            textAlign: "right",
        },
        "&.show-menu": {
            ".app-header-links": {
                height: "auto",
            },
            ' .m-links': {
                display: 'grid',
            },
        },
        ' li.muk-navlink.active': {
            backgroundColor: '#ddd !important',
        },
        ' .muk-nav': {
            fontSize: '14px',
            fontWeight: 'normal',
            ' a': {
                padding: '5px',
                borderBottomWidth: 'inherit !important',
            },
            ' .m-logo': {
                padding: 0,
            },
        },
        ' .m-image': {
            height: '20px',
            padding: 0,
            margin: 0,
        },
    },
}, props => ({
    marginTop: props.isWidget ? "100px" : undefined,
}))


const MobileMenu = css("span")({
    position: "absolute",
    top: "25px",
    right: "20px",
    cursor: 'pointer',
    zIndex: 10901,
    ' ul.m-links': {
        display: 'grid',
    },
    '@media screen and (min-width: 1024px)': {
        display: 'none',
        visibility: 'hidden',
    },
})

const Logo = css("span")({
    position: "relative",
    display: "inline-block",
    verticalAlign: "middle",
    width: "32px",
    cursor: "pointer",
    textAlign: "center",
    " .muk-icon--feedimageeditor": {
        transform: "rotate3d(0,0,0,0deg)",
        transition: "transform 0.1s",
        transitionDelay: "0.1s",
    },
    "&:hover .muk-icon--feedimageeditor": {
        transform: "rotate3d(0,0.1,0,90deg)",
        transitionDelay: "0s",
    },
    " .muk-icon--refresh": {
        position: "absolute",
        left: "2px",
        top: "3px",
        transform: "rotate3d(0,-0.1,0,90deg)",
        transition: "transform 0.1s",
        transitionDelay: "0s",
    },
    "&:hover .muk-icon--refresh": {
        transform: "rotate3d(0,0,0,0deg)",
        transitionDelay: "0.1s",
    },
    "&:focus": {
        border: "none",
        outline: "none",
    },
    " .muk-icon--refresh .muk-icon__image": {
        transform: "rotate3d(0,0,1,0deg)",
        transitionDelay: "0s",
        transitionDuration: "0.2s",
    },
    "&:focus .muk-icon--refresh .muk-icon__image": {
        transform: "rotate3d(0,0,1,360deg)",
        transitionDelay: "0s",
        transitionDuration: "0.2s",
    }
})

function mapStateToProps(state, props) {
    return {
        project: state.project.data,
        blockNavigation: state.blockNavigation,
    }
}

export default connect(mapStateToProps, {
    setBlockNavigation,
})(withRouter(Header));